import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { baseUrl } from "../utils/utils";
import moment from "moment";

var today = new Date();
today.setHours(today.getHours() - 6);

export const get_cone_data = createAsyncThunk("cone", async (data) => {
  var formdata = new FormData();
  formdata.append("userid", data.userid);
  formdata.append("branchid", data.id);
  formdata.append("start", moment(today).format("YYYY-MM-DD HH:mm:ss"));
  formdata.append("end", moment(new Date()).format("YYYY-MM-DD HH:mm:ss"));

  const responce = await fetch(baseUrl + "waflist", {
    method: "POST",
    body: formdata,
  });
  const res = await responce.json();
  //   console.log("cone", res);
  return res;
});

const coneSlice = createSlice({
  name: "cone",
  initialState: {
    cone_list: [],
    cone_loading: false,
  },
  extraReducers: (builder) => {
    builder.addCase(get_cone_data.pending, (state, action) => {
      state.cone_loading = true;
    });
    builder.addCase(get_cone_data.rejected, (state, action) => {
      state.cone_loading = false;
    });
    builder.addCase(get_cone_data.fulfilled, (state, action) => {
      state.cone_loading = false;
      const data = action.payload;
      if (data.success) {
        state.cone_list = data.list;
      } else {
        state.cone_list = [];
      }
    });
  },
});
export default coneSlice.reducer;
